import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";  // Import useParams
import { Endpoints } from "../../repository/Endpoints";
import { GetMaker } from "../../repository/RequestMaker";
import { Language } from "./Language"

const TrainingsPage = () => {
  const { projectId } = useParams(); // Extract projectId from URL
  const history = useHistory();
  const [trainings, setTrainings] = useState([]);
  const [loading, setLoading] = useState(true);
  const language = localStorage.getItem("language");

  // Fetch trainings based on project ID
  useEffect(() => {
    if (projectId) {
      const endpoint = Endpoints.get_trainings(projectId);
      GetMaker(endpoint).then((res) => {
        if (res && res.data) {
          setTrainings(res.data);
          setLoading(false);
        } else {
          console.error("Failed to fetch trainings");
        }
      });
    }
  }, [projectId]);


  const handleTrainingClick = (trainingId) => {
    localStorage.setItem("selected_training_id", trainingId);
    // history.push({
    //   pathname: "/userdata",
    // });

    history.push({
      pathname: "/userdatAll",
    });
  };
  

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="bg-mine">

    <div className="training-page">
      <h1 className="text-title-color" id="title_text">{Language[language].select_structure_type}</h1>
      <br/> 
      <div className="button-group">
        {trainings.map((training) => (
          <button
            key={training.id}
            className="styled-button"
            onClick={() => handleTrainingClick(training.id)}
          >
            {training.name}
          </button>
        ))}
      </div>
    </div>
    </div>
  );
};

export default TrainingsPage;
